module.exports = __webpack_public_path__ + "img/money-back-guarantee.ff955921.webp";